import { entityScripts } from "@/lib/entityJsonLd";
import { createFileRoute } from "@tanstack/react-router";
import PlayerHub from "@/pages/PlayerHub";
import { MainLayout } from "@/components/layout/MainLayout";
import { readable, socialMeta } from "@/lib/routeSocial";

export const Route = createFileRoute("/players/$slug")({
  head: ({ params }) => {
    const name = readable(params.slug);
    return {
      scripts: entityScripts({ type: "Person", name: name, path: `/players/${params.slug}`, crumbs: [{ name: "Players", path: "/players" }, { name: name, path: `/players/${params.slug}` }], extra: { jobTitle: "Footballer" } }),
      meta: socialMeta({
        seo: { topics: ["players"], entities: [readable(params.slug)] },
        title: `${name} Stats, Form & Match Predictions | Statlign`,
        description: `${name} form, involvement and how our 50-strategy engine factors player impact into match predictions and betting tips.`,
      }),
    };
  },
  component: () => (
    <MainLayout>
      <PlayerHub />
    </MainLayout>
  ),
});
